import { useContext, useState } from "react";
import { Wrapper, Button, EmptyCart, ButtonLink, HeaderTemplate, CartTemplate, PageTemplate } from "../styles";
import { DataContext } from "../DataContext";
import CartProduct from "../components/CartProduct";
import { Modal } from "react-bootstrap";
import SizeChart from "../components/SizeChart";

const Cart = () => {
  const { productsInCart, getSubTotal } = useContext(DataContext);
  const productsCount = productsInCart.reduce((sum, product) => sum + product.quantity, 0);

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {productsCount > 0 ? (
        <>
          <HeaderTemplate className="narrow">
            <div className="header flex-header with-size-key">
              {productsCount > 0 && (
                <>
                  <div className="title">
                    <h1>Shopping Bag</h1>
                  </div>
                  <div className="size-key">
                    <div>
                      Short<span>S</span>
                    </div>
                    <div>
                      Regular<span className="reg">R</span>
                    </div>
                  </div>
                </>
              )}
            </div>
          </HeaderTemplate>
          <CartTemplate>
            <div>
              <div className="cart-products-column">
                {productsInCart.map((currentProduct, idx) => (
                  <CartProduct key={idx} product={currentProduct}></CartProduct>
                ))}
              </div>
            </div>
            <div className="cart-bottom-boxes">
              <div className="size-guide">
                <span>
                  Before checking out, review the <strong>Size Guide</strong>
                </span>
                <Button className="size-guide-button white" onClick={() => setShowModal(true)}>
                  View Size Guide
                </Button>
              </div>
              <div className="cart-checkout-box">
                <div className="cart-total">
                  Subtotal<span>${getSubTotal()}</span>
                </div>
                <ButtonLink className="checkout-button yellow" to="/checkout">
                  Checkout
                </ButtonLink>
              </div>
            </div>
          </CartTemplate>
          <Modal size="xl" fullscreen={"md-down"} show={showModal} animation={false} onHide={() => setShowModal(false)}>
            <Wrapper className="modal-styles">
              <Modal.Header closeButton>
                <Modal.Title>Size Guide</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <PageTemplate className="size-guide-modal">
                  <SizeChart />
                </PageTemplate>
              </Modal.Body>
            </Wrapper>
          </Modal>
        </>
      ) : (
        <EmptyCart>
          <h1>Your Shopping Bag is Empty</h1>
          <ButtonLink to="/designs" className="autoWidth">
            Browse Designs
          </ButtonLink>
        </EmptyCart>
      )}
    </>
  );
};
export default Cart;
